'use strict';

/**
 * Style options for leaflet layers
 */

var _ = require('lodash');

var _DEFAULT_PATH_COLOR = '#3889BE'; // Steel blue

var MARKER_DEFAULTS = {
  icon: null,
  color: '#217BC9'
};

var TEXT_DEFAULTS = {
  iconAnchor: [0, 32],
  className: 'text-marker'
};

var PATH_DEFAULTS = {
  color: _DEFAULT_PATH_COLOR,
  fill: false,
  opacity: 0.5,
  weight: 5
};

var POLYGON_DEFAULTS = _.extend({}, PATH_DEFAULTS, {
  fill: true,
  fillOpacity: 0.3,
});

var OVERLAY_DEFAULTS = {
  // Does not contain default styles, placeholder for future styles and added
  // for consistency with other types
};

var Styles = {
  marker: {
    active: MARKER_DEFAULTS,
    default: MARKER_DEFAULTS,
    dim: MARKER_DEFAULTS
  },

  circle: {
    active: _.extend({}, POLYGON_DEFAULTS, {
      fillOpacity: 0.5,
      opacity: 0.7
    }),
    default: POLYGON_DEFAULTS,
    dim: _.extend({}, POLYGON_DEFAULTS, {
      fillOpacity: 0.1,
      opacity: 0.3
    })
  },

  // polygon (area) specific styles
  polygon: {
    active: _.extend({}, POLYGON_DEFAULTS, {
      fillOpacity: 0.5,
      opacity: 0.7
    }),
    default: POLYGON_DEFAULTS,
    dim: _.extend({}, POLYGON_DEFAULTS, {
      fillOpacity: 0.1,
      opacity: 0.3
    })
  },

  // polyline (line) specific styles
  polyline: {
    active: _.extend({}, PATH_DEFAULTS, {
      opacity: 0.7
    }),
    default: PATH_DEFAULTS,
    dim: _.extend({}, PATH_DEFAULTS, {
      opacity: 0.3
    })
  },

  // rectangle specific styles
  rectangle: {
    active: _.extend({}, POLYGON_DEFAULTS, {
      fillOpacity: 0.5,
      opacity: 0.7
    }),
    default: POLYGON_DEFAULTS,
    dim: _.extend({}, POLYGON_DEFAULTS, {
      fillOpacity: 0.1,
      opacity: 0.3
    })
  },

  // text marker specific styles
  text: {
    active: TEXT_DEFAULTS,
    default: TEXT_DEFAULTS,
    dim: TEXT_DEFAULTS
  },

  // overlay specific styles
  overlay: {
    active: OVERLAY_DEFAULTS,
    default: OVERLAY_DEFAULTS,
    dim: OVERLAY_DEFAULTS
  }
};

module.exports = Styles;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/draw/lib/LayerStyles.js